import React, {FC} from "react"
import {CSSTransition} from "react-transition-group"

import {IconTypes} from "@irati/ui/src/Icon"

import {ContentButtons, EditButtons, StyledContentHover} from "./styled"

interface Props {
  handleDeleteTile: () => void,
  handleEditTile: () => void,
  isOnHover: boolean
}

const ContentHover: FC<Props> = ({handleEditTile, handleDeleteTile, isOnHover}) => (
  <CSSTransition
    classNames="homepage-edit-tile-overlay"
    in={isOnHover}
    timeout={{
      enter: 200,
      exit: 200
    }}
    unmountOnExit>
    <StyledContentHover>
      <ContentButtons>
        <EditButtons icon={IconTypes.edit} onClick={() => handleEditTile()} />
        <EditButtons icon={IconTypes.bin} onClick={() => handleDeleteTile()} />
      </ContentButtons>
    </StyledContentHover>
  </CSSTransition>
)

export default ContentHover
